import { actions } from "./action-list";

export function setNotificationMessage(value) {
  return {
    type: actions.NOTIFICATION,
    value,
  };
}
